import { useBreadcrumb } from "features/breadcrumbs";

import ContentConta from "components/Features/Financeiro/ContentConta";
import { useContaStore } from "features/conta/store";
import { OperacaoEnum } from "resources/enums/conta";
import { useEffect } from "react";

function PagarListagemPage() {
  const { update } = useContaStore();

  useEffect(() => {
    update("operacao", OperacaoEnum.Despesa);
  }, [update]);

  useBreadcrumb([
    { name: "Financeiro" },
    { name: "Despesas" },
    { name: "Contas a pagar" },
  ]);

  return (
    <>
      <ContentConta />
    </>
  );
}

export default PagarListagemPage;
